import React from 'react'

const Bot = ({ style }) => (
  <svg
    width="39px"
    height="39px"
    viewBox="0 0 39 39"
    version="1.1"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      transform="translate(-324.000000, -328.000000) translate(12.000000, 163.000000) translate(1.000000, 107.000000) translate(311.000000, 58.000000)"
      fillRule="nonzero"
      stroke="none"
      strokeWidth={1}
      fill="none"
    >
      <circle fill="#4153B8" cx="19.5" cy="19.5" r="19.5" />
      <rect
        fill="#FFF"
        x="18.5714286"
        y="6.68571429"
        width="1.48571429"
        height="5.94285714"
      />
      <circle fill="#FFF" cx="19.5" cy="6.12857143" r="1.67142857" />
      <g transform="translate(7.000000, 10.000000)">
        <rect fill="#FFF" x={0} y={0} width={25} height={20} rx={10} />
        <rect
          fill="#CCF0FF"
          x="2.94117647"
          y="4.81481481"
          width="19.1176471"
          height="10.3703704"
          rx="5.18518519"
        />
        <g transform="translate(6.617647, 8.518519)" fill="#0465C0">
          <ellipse
            cx="1.47058824"
            cy="1.48148148"
            rx="1.47058824"
            ry="1.48148148"
          />
          <ellipse
            cx="10.6617647"
            cy="1.48148148"
            rx="1.47058824"
            ry="1.48148148"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default Bot
